<div class="mainLoader" *ngIf="loading==true">
  <div class="loader"></div>
</div>
   <!--<app-loading-screen *ngIf="loading==true"></app-loading-screen> TODO : Make Loader as an module-->
<div class="loginModule">
  <div class="loginWrapper">
    <div class="loginWrapperLeft">
      <a href="/" class="loginLogo"><img src="../../assets/logoSmall.svg" /></a>
      <h3>Forgot Password</h3>
      <!--<div class="choicetoLogin" style="margin-top:20px;">
        <label [ngClass]="loginWithOtp == false ? 'choicetoLoginSelected' : ''" style="margin-right:2px;">
          <input type="radio" title="Email" value="Email" id="Email" class="radioChoice" name="loginWithOtp" (change)="radioChange($event)" checked />
          <span for="Email">Email</span>
        </label>
        <label [ngClass]="loginWithOtp == true ? 'choicetoLoginSelected' : ''" for="Phone">
          <input type="radio" title="Phone number" value="Phone" id="Phone" class="radioChoice" name="loginWithOtp" (change)="radioChange($event)" />
          <span for="Phone">Phone Number</span>
        </label>
      </div>-->

      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" *ngIf="loginWithOtp == false">
        <div class="form-group">
          <label for="email" class="form-label">Email AddRess</label>
          <input type="email" class="form-control" id="email" placeholder="" formControlName="email"
                 [ngClass]="{'invalid': submitted && f['email'].invalid}" />
          <div *ngIf="submitted && f['email'].invalid">
            <p style="color: red;">
              Please provide a valid Email.
            </p>
          </div>
        </div>

        <div class="buttonGroup d-grid">
          <button type="submit" class="btn btn-secondary w-100">Submit</button>
          <hr />
          <!-- <button type="button" class="btn btn-light  w-100">Create Account</button> -->
        </div>
      </form>
      <form *ngIf="loginWithOtp == true">
        <div class="form-group">
          <label for="phone" class="form-label">Phone number</label>
          <div class="position-relative">
            <input type="text"
                   style="padding-left:1.5rem" class="form-control"
                   [(ngModel)]="phonenumber" name="phonenumber" id="phone" placeholder="" maxlength="14" />
          </div>
        </div>
        <div class="buttonGroup d-grid">
          <button type="submit" class="btn btn-secondary w-100" (click)="onSubmitPhone()">Submit</button>
          <hr />
        </div>
      </form>
      <div class="buttonGroup d-grid">
        <!-- <button type="submit" class="btn btn-secondary w-100">Sign In</button> -->
        <!-- <hr /> -->
        <button type="button" class="btn btn-light  w-100" [routerLink]="['/']">Sign In</button>
      </div>

    </div>
    <div class="loginWrapperRight d-none d-sm-inline-flex">
      <figcaption>
        <h1 class="font_med">Welcome to PharmaVision</h1>
        <h5>
          Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,
          consectetur, adipisci velit
        </h5>
      </figcaption>
    </div>
  </div>

</div>
<!--</ng-template>-->
